import type {
  IImpressionTeaser,
  IImpressionWidget,
  IImpressionUIElement,
  InputParams,
} from '@schibsted/pulse-sdk';
import type { ByfunnPulseContextInputParams } from '../../types.js';

import { createObjectSdrn } from './create-object-sdrn.js';

type ImpressionEvent =
  | IImpressionTeaser
  | IImpressionWidget
  | IImpressionUIElement;

type ElementType = 'Teaser' | 'Widget' | 'UIElement';

export const buildImpressionEvent = <TEvent extends ImpressionEvent>({
  elementType,
  event,
  providerId,
  providerInput,
}: {
  elementType: ElementType;
  event: string;
  providerId: string;
  providerInput: InputParams<TEvent>['provider'];
}): InputParams<TEvent> => {
  const parsed = JSON.parse(event) as ByfunnPulseContextInputParams<TEvent>;

  return {
    ...parsed,
    object: {
      ...parsed.object,
      objectSdrn: createObjectSdrn(
        providerId,
        elementType,
        parsed.object.objectId,
      ),
    },
    provider: providerInput,
  } as InputParams<TEvent>;
};
